var _circle, _path, _path2, _g, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCelebration = function SvgCelebration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 137,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.28,
    cy: 83.015,
    r: 48.877,
    fill: "url(#celebration_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.67 47.79 8.812 119.436c-2.73 5.306 2.978 10.981 8.268 8.22l70.875-36.98c2.081-1.085 2.521-3.874.874-5.549L51.27 46.938c-1.67-1.697-4.51-1.264-5.6.853Z",
    fill: "url(#celebration_svg__b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "celebration_svg__d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 46,
    width: 82,
    height: 83
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.626 48.009 8.862 119.185c-2.738 5.302 2.96 10.986 8.254 8.234l70.715-36.745c2.088-1.086 2.528-3.883.875-5.558L51.218 47.157c-1.67-1.69-4.502-1.258-5.592.852Z",
    fill: "url(#celebration_svg__c)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#celebration_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m54.436 39.23-9.26 3.797 24.718 60.267 9.259-3.798L54.436 39.23ZM26.85 60.487l9.26-3.798 23.269 56.738-9.26 3.798-23.27-56.738Zm-3.672 17.715L13.919 82l20.254 49.383 9.259-3.798-20.253-49.382ZM6.756 87.195l-9.26 3.797 20.253 49.383 9.26-3.798L6.756 87.195Z",
    fill: "url(#celebration_svg__e)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.957,
    cy: 68.146,
    rx: 30.09,
    ry: 7.959,
    transform: "rotate(46.11 67.957 68.146)",
    fill: "url(#celebration_svg__f)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.097 16.06a1.31 1.31 0 0 1 1.664.817c1.21 3.55 3.405 12.886 2.638 22.279-.78 9.558-6.46 17.88-9.228 20.892a1.31 1.31 0 0 1-1.93-1.774c2.534-2.757 7.83-10.555 8.546-19.331.73-8.942-1.379-17.91-2.507-21.22a1.31 1.31 0 0 1 .817-1.663ZM94.765 13.664c.717-.1 1.38.4 1.48 1.116.558 3.986.977 13.866-1.946 21.466-2.89 7.514-9.326 15.87-12.165 19.103a1.31 1.31 0 0 1-1.97-1.73c2.773-3.158 8.966-11.235 11.689-18.314 2.69-6.993 2.329-16.352 1.796-20.162-.1-.716.4-1.379 1.116-1.48Zm37.861 59.886c-4.914-2.96-12.47-7.512-25.184-6.534-11.273.867-17.605 5.627-21.747 8.848a1.31 1.31 0 0 1-1.609-2.069c4.278-3.327 11.11-8.466 23.155-9.392 13.597-1.046 21.843 3.94 26.766 6.915.751.455 1.425.862 2.029 1.194a1.31 1.31 0 0 1-1.263 2.297c-.656-.36-1.368-.79-2.147-1.259Z",
    fill: "#DEE4FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F76E63",
    d: "m73.779 44.38 3.23 1.297-1.298 3.23-3.229-1.298z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#526EED",
    d: "m86.383 60.256 3.926-9.015 3.22 1.402-3.926 9.016z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.639 53.476a5.191 5.191 0 0 0-7.091 1.9l4.495 2.596 2.596-4.496ZM85.987 40.24a4.313 4.313 0 0 0-3.05-5.283l-1.116 4.166 4.166 1.116Z",
    fill: "#4E6DF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.292 15.182a4.392 4.392 0 0 0-5.393 3.082l4.237 1.156 1.156-4.238Z",
    fill: "#D1DFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.209 32.119a4.21 4.21 0 0 0-5.155-2.977l1.089 4.066 4.066-1.09Z",
    fill: "#F7D7D7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.532 76.084a5.19 5.19 0 0 0-.322-7.335l-3.506 3.829 3.828 3.506Z",
    fill: "#4E6DF5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M108.808 38.706a5.191 5.191 0 0 0-6.358-3.67l1.344 5.014 5.014-1.344Z",
    fill: "#FFA66B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m81.064 32.541-.11-.066.054.033.056.033Zm-.156-.094a5.563 5.563 0 0 1 5.723-9.539l-1.706 2.844a2.249 2.249 0 0 0-2.311 3.851l-1.706 2.844Z",
    fill: "#8978F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.942 74.931a4.354 4.354 0 0 1-7.033-5.13l2.096 1.53a1.76 1.76 0 0 0 2.84 2.07l2.097 1.53Zm-6.938-5.261-.041.056-.041.056.082-.112Z",
    fill: "#FFA66B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m97.73 45.97.092-.008-.046.004-.045.005Zm.187-.015a6.651 6.651 0 0 1 1.21 13.245l-.36-3.949a2.689 2.689 0 0 0-.49-5.348l-.36-3.948Z",
    fill: "#F76E63"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m82.144 66.837-.002.11.001-.055v-.055Zm-.006.235a8.413 8.413 0 0 1-16.82-.27l5.014.08a3.401 3.401 0 0 0 6.792.109l5.014.08Z",
    fill: "#5FC6B9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#526EED",
    d: "m111.703 55.624 8.158 1.444-.516 2.914-8.158-1.444z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F76E63",
    d: "m93.668 72.96 8.66 4.275-1.527 3.093-8.66-4.276z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9BB3FA",
    d: "m110.849 46.907 5.663-5.753 2.055 2.022-5.664 5.754z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.308 57.125a4.24 4.24 0 0 1 3.268-7.823l-.974 2.332a1.714 1.714 0 0 0-1.32 3.16l-.974 2.331Zm3.407-7.766-.055-.023-.056-.023.111.046Z",
    fill: "#FFE46B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.657 23.044a5.16 5.16 0 0 1-10.18 1.675l3.034-.5a2.086 2.086 0 0 0 4.111-.675l3.035-.5ZM98.443 24.51a6.06 6.06 0 0 0 .033.204l-.033-.204Z",
    fill: "#F7A9A3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "celebration_svg__a",
    x1: 50.28,
    y1: 34.138,
    x2: 50.28,
    y2: 131.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99B0E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "celebration_svg__b",
    x1: 46.07,
    y1: 43.492,
    x2: 46.07,
    y2: 136.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "celebration_svg__c",
    x1: 46.028,
    y1: 43.732,
    x2: 46.028,
    y2: 136.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EAF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "celebration_svg__e",
    x1: 61.561,
    y1: 73.038,
    x2: 4.925,
    y2: 133.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "celebration_svg__f",
    x1: 67.957,
    y1: 60.187,
    x2: 67.957,
    y2: 76.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8D1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BCEC"
  })))));
};
export default SvgCelebration;